import Vue from "vue";

export const SET_ME = (state, payload) => (state.me = payload);
export const SET_MATCH_ME = (state, payload) =>
  Vue.set(state, "match", { ...payload });
export const SET_PASSWORD_RESET_EMAIL = (state, email) =>
  (state.passwordReset.email = email);
export const SET_PASSWORD_RESET_CONFIRMATION_CODE = (state, code) =>
  (state.passwordReset.confirmationCode = code);
export const CLEAR_PASSWORD_RESET = state => {
  state.passwordReset.email = "";
  state.passwordReset.confirmationCode = "";
};
export const SET_GROUP_MATCH_DATA = (state, payload) => {
  let data = [];
  for (let i = 0; i < payload["results"].length; i++) {
    data.push(payload["results"][i]["result"]);
  }
  state.match = data;
};
